"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XHRPluginXSecurity = exports.XHRPluginXSecurityConstants = void 0;
const core_1 = require("../../../core");
/**
 *
 * @deprecated please use from web-ui-security instead
 * @link https://github.com/santander-group-ods/SOFTWEB-web-ui-security | web-ui-security
 *
 */
var XHRPluginXSecurityConstants;
(function (XHRPluginXSecurityConstants) {
    XHRPluginXSecurityConstants["XHR_EXPIRED_HEADER_NAME"] = "x-security";
})(XHRPluginXSecurityConstants || (exports.XHRPluginXSecurityConstants = XHRPluginXSecurityConstants = {}));
/**
 *
 * @deprecated please use from web-ui-security instead
 * @link https://github.com/santander-group-ods/SOFTWEB-web-ui-security | web-ui-security
 *
 */
class XHRPluginXSecurity {
    constructor() {
        this.name = this.constructor.name;
    }
    handleResponse(response) {
        let responseHeaders = response.data.responseHeaders;
        if (responseHeaders) {
            Object.keys(responseHeaders).forEach(key => {
                // xSecurityHeaders
                const value = responseHeaders[key];
                if (key === XHRPluginXSecurityConstants.XHR_EXPIRED_HEADER_NAME && value) {
                    delete response.data.responseHeaders[key]; // intentional remove header to parsed
                    responseHeaders = this.transformValuesFromXSecurity(value, responseHeaders);
                }
                else {
                    responseHeaders[key] = value;
                }
            });
            response.data.responseHeaders = responseHeaders;
        }
        return Promise.resolve(response);
    }
    transformValuesFromXSecurity(value, responseHeaders) {
        value
            .toLowerCase()
            .split(',')
            .forEach(header => {
            /**
             * it was changed by login team request (ruben lopez and cristian bietti)
             * if it gives the XHRConstants.XHR_EXPIRED_HEADER_NAME and it does not have a value it returns true else return the value split
             */
            const splitHeader = header
                .toLowerCase()
                .split(':')
                .map(headerIn => headerIn.trim());
            // Log.log(new Map(response.headers)); // to check the headers and values
            /* any intentional because can be string, boolean or undefined, but I made validations for that */
            let headerValue = splitHeader[1];
            if (!headerValue) {
                headerValue = true;
            }
            else {
                if ((0, core_1.isString)(headerValue)) {
                    if ((0, core_1.isBooleanFromString)(headerValue)) {
                        headerValue = JSON.parse(headerValue.toLowerCase());
                    }
                    else {
                        headerValue = headerValue.trim();
                    }
                }
            }
            responseHeaders[splitHeader[0]] = headerValue;
        });
        return responseHeaders;
    }
}
exports.XHRPluginXSecurity = XHRPluginXSecurity;
//# sourceMappingURL=XSecurity.js.map